import type { FC } from "react";
import { useCallback, useState } from "react";

import type { BuilderBlock } from "@builder.io/sdk-react";
import { Blocks, isEditing } from "@builder.io/sdk-react";
import classNames from "classnames";

import { Typography } from "@jti/ui/components/Typography";

import styles from "./LoyaltyTabs.module.scss";

type Tab = {
  label: string;
  blocks: BuilderBlock[];
};

export type LoyaltyTabsProps = {
  title: string;
  tabList: Tab[];
  defaultActiveTab?: number;
  builderBlock: BuilderBlock;
};

export const LoyaltyTabs: FC<LoyaltyTabsProps> = ({ title, tabList, defaultActiveTab = 0, builderBlock }) => {
  const isInEditMode = isEditing();
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const handleTabChange = useCallback((index: number) => {
    setActiveTab(index);
  }, []);

  if (!tabList?.length) {
    return isInEditMode ? <span className={styles.addTabText}> Please add tabs</span> : null;
  }

  return (
    <div>
      {/* DEPRECATED_Typography is used originally in Tabs component coming from loyalty repo, there are no designs for this part yet so its temporarily like this */}
      <Typography variant="h2" weight="light" className={styles.title} as="div">
        {title}
      </Typography>
      <ol className={styles.tabList}>
        {tabList.map((tab, index) => (
          <button
            key={index}
            className={classNames(styles.tabItem, {
              [styles.tabItemActive as string]: activeTab === index,
            })}
            onClick={() => handleTabChange(index)}
            data-testid={`loyaltyTab${index}`}
          >
            {tab.label}
          </button>
        ))}
      </ol>
      <Blocks parent={builderBlock?.id} path={`tabList.${activeTab}.blocks`} blocks={tabList[activeTab]?.blocks} />
    </div>
  );
};
